<template>
  <div>
    <el-dialog
      top="11vh"
      :title="title"
      :visible.sync="visibleSync"
      width="90%"
      :before-close="onCancel"
    >
      <br />
      <b>S</b>: Severidad,
      <b>P</b>: Probabilidad,
      <b>IR</b>: Indice de Riesgo.
      <br />
      <br />
      <el-table
        border
        :header-cell-style="function () { return 'background-color: rgb(7, 116, 141); color: white; padding: 0px;'}"
        :cell-class-name="pintar"
        @selection-change="handleSelectionChange"
        :default-sort="{prop: 'mfl', order: 'descending'}"
        :data="risks"
        style="width: 100%"
        :max-height="600"
        empty-text="Sin Riesgos Transversales"
        header-cell-class-name="headerCell"
      >
        <el-table-column type="expand" width="30">
          <template slot-scope="scope">
            <el-row>
              <el-col :span="8">
                <h4>Causas</h4>
                <ol>
                  <li v-for="(item, index) in scope.row.causas" :key="index">{{item.nombre}}</li>
                </ol>
              </el-col>
              <el-col :span="8">
                <h4>Controles Preventivos</h4>
                <ol>
                  <li
                    :class="{fontRed: control.critico}"
                    v-for="(control, i) in getControlesPreventivos(scope.row)"
                    v-bind:key="i"
                  >{{control.nombre}}</li>
                </ol>
              </el-col>
              <el-col :span="8">
                <h4>Controles Mitigadores</h4>
                <ol>
                  <li
                    v-for="(control, i) in getControlesMitigadores(scope.row)"
                    v-bind:key="i"
                  >{{control.nombre}}</li>
                </ol>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column align="center" type="selection"></el-table-column>
        <el-table-column prop="nombre" label="Nombre" />
        <el-table-column align="center" width="250" label="Categoría">
          <template slot-scope="scope">{{scope.row.tipo ? MaysPrimera(scope.row.tipo) : ""}}</template>
        </el-table-column>
        <el-table-column align="center" label="Sin Controles">
          <el-table-column align="center" label="S" width="130">
            <template slot-scope="scope">{{(scope.row.sin_controles && scope.row.sin_controles.severidad) || "---"}}</template>
          </el-table-column>
          <el-table-column align="center" label="P" width="130">
            <template slot-scope="scope">{{(scope.row.sin_controles && scope.row.sin_controles.probabilidad) || "---"}}</template>
          </el-table-column>
          <el-table-column align="center" label="IR" width="130">
            <template
              slot-scope="scope"
            >{{ (scope.row.sin_controles && scope.row.sin_controles.probabilidad && scope.row.sin_controles.severidad) ? (scope.row.sin_controles.probabilidad * scope.row.sin_controles.severidad) : "---"}}</template>
          </el-table-column>
        </el-table-column>
        <el-table-column align="center" label="Con Controles">
          <el-table-column align="center" label="S" width="130">
            <template slot-scope="scope">{{(scope.row.con_controles && scope.row.con_controles.severidad) || "---"}}</template>
          </el-table-column>
          <el-table-column align="center" label="P" width="130">
            <template slot-scope="scope">{{(scope.row.con_controles && scope.row.con_controles.probabilidad) || "---"}}</template>
          </el-table-column>
          <el-table-column align="center" label="IR" width="130">
            <template
              slot-scope="scope"
            >{{(scope.row.con_controles && scope.row.con_controles.probabilidad && scope.row.con_controles.severidad) ? (scope.row.con_controles.probabilidad * scope.row.con_controles.severidad) : "---"}}</template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="onCancel">Cancelar</el-button>
        <el-button size="medium" type="primary" @click="onAcept">Aceptar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: [
    "onCancel",
    "onAcept",
    "risks",
    "visibleSync",
    "title",
    "handleSelectionChange"
  ],
  methods: {
    MaysPrimera(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    pintar({ row, column, rowIndex, columnIndex }) {
      let classes = "cellClassTabla ";
      if (columnIndex === 0) {
        if (row.custom === true) {
          classes += "colorCustom";
        } else if (row.impactos[0].categoria === "Seguridad" && !row.custom) {
          classes += "colorSeguridad";
        } else if (row.impactos[0].categoria === "Salud" && !row.custom) {
          classes += "colorSalud";
        } else if (
          row.impactos[0].categoria === "Salud y Seguridad" &&
          !row.custom
        ) {
          classes += "colorSaludySeguridad";
        } else if (
          row.impactos[0].categoria === "Medioambiente" &&
          !row.custom
        ) {
          classes += "colorMedioambiente";
        }
      }
      return classes;
    },
    getControlesMitigadores(risk) {
      const controles = [];
      if (risk.impactos) {
        risk.impactos.forEach((impacto, index) => {
          const id = `IM${index + 1}`;
          if (impacto.controles_mitigadores) {
            impacto.controles_mitigadores.forEach(control => {
              control.id_impacto = id;
              control.impactoId = impacto.id;
              controles.push(control);
            });
          }
        });
      }
      return controles;
    },
    getControlesPreventivos(risk) {
      const controlesIndicator = {};
      if (risk.causas) {
        risk.causas.forEach((causa, index) => {
          const humanID = `CA${index + 1}`;
          if (causa.controles_preventivos) {
            causa.controles_preventivos.forEach(control => {
              if (!controlesIndicator[control.nombre]) {
                controlesIndicator[control.nombre] = {};
                controlesIndicator[control.nombre].critico = control.critico;
                controlesIndicator[control.nombre].id = control.id;
              }
              if (!controlesIndicator[control.nombre].causasHumanID) {
                controlesIndicator[control.nombre].causasHumanID = [];
                controlesIndicator[control.nombre].causasID = [];
              }
              controlesIndicator[control.nombre].causasHumanID.push(humanID);
              controlesIndicator[control.nombre].causasID.push(causa.id);
            });
          }
        });
      }
      const controles = Object.keys(controlesIndicator).map(key => ({
        causasHumanID: controlesIndicator[key].causasHumanID,
        causasID: controlesIndicator[key].causasID,
        nombre: key,
        critico: controlesIndicator[key].critico,
        id: controlesIndicator[key].id
      }));
      return controles;
    }
  }
};
</script>

<style scoped>
.fontRed {
  color: red;
}
.headerCell {
  padding: 0px !important;
}
</style>
